<app-spinner [loading]="areSlotsLoading()"></app-spinner>
<section class="new-cryptotoken">
  <h1 class="new-cryptotoken__title">{{labels.title}}</h1>
  <form [formGroup]="form" appFormFields (ngSubmit)="onSubmit()" class="new-cryptotoken__form">
    <app-card class="new-cryptotoken__card">
      <div class="new-cryptotoken__inputs">
        <app-form-field [name]="CryptoTokenField.tokenType" class="new-cryptotoken__tokenType"></app-form-field>
        <app-form-field [name]="CryptoTokenField.tokenName" class="new-cryptotoken__tokenName"></app-form-field>
        <app-form-field [name]="CryptoTokenField.autoActivation" class="new-cryptotoken__autoActivation"></app-form-field>
        <app-form-field [name]="CryptoTokenField.secret" class="new-cryptotoken__secret"></app-form-field>
        @if(isPKCS11()) {
          <app-form-field [name]="CryptoTokenField.slotLabel"></app-form-field>
        }
      </div>
      <div class="new-cryptotoken__buttons">
        <button type="button" mat-button class="button" (click)="onCancel()">{{labels.buttons.cancel}}</button>
        <button type="submit" mat-button class="button button_primary">{{labels.buttons.ok}}</button>
      </div>
    </app-card>
  </form>
</section>